<template>
<b-container class="register-organization-container">
        <div class="login-form-wrapper">

	<branding-heading></branding-heading>
<b-row v-show="loading">
	<b-col class="pb-3">
		<b-spinner label="Checking Your Confirmation Code..."></b-spinner> Checking server... please wait...
	</b-col>
</b-row>
<b-row v-show="status == 'success'">
	<b-col >
	<h2>Waiting for Approval</h2>
	<p>Thank you for confirming your email address.</p>
	<p><strong>Your organization will review your account for approval and notify you by email.</strong></p>
	<p>When approved, you will be able to login.</p>
	<p><router-link to="/" class="btn btn-primary">Back to Lane Closures</router-link></p>
	</b-col>
</b-row>
<b-row v-show="status == 'error'">
	<b-col >
	<h2>There was a problem confirming your email address.</h2>
	<p>Please make sure that the link you clicked on in your email contains the full URL.</p>
	<p><router-link to="/" class="btn btn-primary">Back to Lane Closures</router-link></p>
	</b-col>
</b-row>
<b-row v-show="status == 'no-token'">
	<b-col >
	<h2>There was a problem confirming your email address.</h2>
	<p>Please make sure that the link you clicked on in your email contains the full URL.</p>
	<p><router-link to="/" class="btn btn-primary">Back to Lane Closures</router-link></p>
	</b-col>
</b-row>

<b-modal centered v-model="showRequiredFieldModal" type="info" @confirm="showRequiredFieldModal = false">
	<template v-slot:modal-title>{{$t('errors.errorsOccurred')}}</template>
	<ul>
		<li v-for="requiredField in modalRequiredFieldList" v-bind:key="'reqfield'+requiredField">{{$t(requiredField)}}</li>
	</ul>
	<template slot="footer">
		<b-button :disabled="isButtonDisabled" colour="light" :value="$t('labels.ok')" @click="modalRequiredFieldClose" />
	</template>
</b-modal>
</div>
</b-container>
</template>
<script>
import BootstrapField from '../../utility/BootstrapField';
import ErrorHandler from '../../utility/ErrorHandler';
import Format from '../../utility/Format';
import Vue from 'vue'
import BrandingHeading from '../../components/BrandingHeading';
export default {
  name: 'ConfirmAppUserRegistration',
  docTitle: "Confirm Email - Lane Closures",

  components: {
    	BrandingHeading
  },
  props:['jwt'],
  data() {
	return {
		Format,
		form: null,
		lineIndexError:null,
		isButtonDisabled: false,
		saveState:null,
		modalRequiredFieldList: [],
		showRequiredFieldModal: false,
		show: true,
		status:null,
		loading:true,
		submitted: false,
		resendToken:null,
		onSubmitPromiseDeferred: {
			resolve:null,
			reject:null
		},
		usernamePrefix:new BootstrapField({
					value: null}),
	}
	},
	mounted() {
		this.sendConfirmToken();
		this.$nextTick(() => {
		})
   },
	computed: {
	},
	watch: {
	},
  methods: {

	// required fields notifying modal
	modalRequiredFieldClose(){
		this.showRequiredFieldModal = false;
	},
	getFlatTree(option) {
		if (option.namePath) {
			return Format.pipesToFlatTree(option.namePath);
		} else {
			return option.name;
		}
	},
	showErrors(errors){
		this.submissionStatus = 'submission-error';
		this.modalRequiredFieldList = [];
		for(let field in errors) {
			this.modalRequiredFieldList.push(errors[field]);
		}
		this.showRequiredFieldModal = true;
	},

		sendConfirmToken() {
			if (this.jwt != null) {
				this.loading = true;
				Vue.prototype.$http({
					method: 'get',
					url: `${this.$store.state.apiUrl}/confirm-user-registration/?jwt=${this.jwt}&r=${Math.round(Math.random() * Math.pow(10, 6))}`
				}).then(response => {
					// Handle Success
					this.loading  = false;
					this.status = "success";
				}).catch(error => {
					this.loading = false;
					this.saveState = 'fail';
					this.status = "error";
					if (!ErrorHandler.HasLoginErrorCode(error)) {
						// this.form.SetErrors(error.response.data);
						// this.showErrors(error.response.data.fields);
					} else {
						// ErrorHandler.RedirectToLogin();
					}
					this.onSubmitPromiseDeferred.reject();
				}).finally(() => {
					this.isButtonDisabled = false;
				});
			} else {
				this.loading = false;
				this.status = 'no-token';
			}
		},

	},
}
</script>
<i18n>
{
	"en-CA": {

	}
}

</i18n>